import { PDFNoteCode } from '../../pages/notes/models/PDFNoteCode';
import { PDFNoteCodeTypeVals } from './PDFNoteCodeTypeVals';

export function formatPDFNoteCodeLabel(code: PDFNoteCode, codeTypeId?: number): string {
  const typeId = code.CodeTypeId ?? codeTypeId;
  if (typeId === PDFNoteCodeTypeVals.Executive) {
    return code.Title ?? '';
  }
  return `${code.Id} - ${code.Title}`;
}
